module.exports = __webpack_public_path__ + "af0572bf3100dc771139249de91fa2fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000OHH.png
// module id = 1612
// module chunks = 0